import { BusinessProfileUpdateStrategy } from '../../../../providers/BusinessProfileProvider';

export default {
  modals: {
    update_strategy: {
      title: '¿Qué ubicaciones se deben actualizar?',
      form: {
        update_strategy: {
          options: {
            [BusinessProfileUpdateStrategy.All]: 'Todas mis ubicaciones',
            [BusinessProfileUpdateStrategy.Current]: 'Solo la ubicación seleccionada actualmente',
          },
        },
      },
      buttons: {
        confirm: 'Confirmar',
      },
    },
  },
  toasts: {
    error: 'Algo salió mal, inténtalo de nuevo o contacta con el soporte técnico',
    success: '¡Los cambios se han guardado correctamente!',
  },
};
